import { Link } from "react-router-dom";
import {
  Wand2, Camera, Plane, Users, Sparkles, MessageSquare, Heart, ArrowUpRight, ArrowRight,
  Scissors, Palette, ScanFace, Droplet, ScanSearch,
} from "lucide-react";

const TOOLS = [
  { to: "/beauty",            icon: ScanFace,   title: "Beauty Studio",   desc: "AI Scan · Makeup · Hair · Care in one place", testId: "tool-beauty" },
  { to: "/outfit-judge",      icon: ScanSearch, title: "OutfitJudge",     desc: "Snap an item before you buy — get Buy / Maybe / Leave", testId: "tool-outfit-judge" },
  { to: "/outfit", icon: Sparkles, title: "Outfit Generator", desc: "AI-curated looks for any occasion", testId: "tool-outfit" },
  { to: "/stylist", icon: MessageSquare, title: "AI Stylist Chat", desc: "Personal style advisor on demand", testId: "tool-stylist" },
  { to: "/tryon", icon: Camera, title: "Try-On Studio", desc: "See outfits on you instantly", testId: "tool-tryon" },
  { to: "/wardrobe", icon: Wand2, title: "Wardrobe", desc: "Smart closet with AI tagging", testId: "tool-wardrobe" },
  { to: "/atelier", icon: Heart, title: "Atelier Picks", desc: "Curated shoppable outfits", testId: "tool-atelier" },
  { to: "/travel", icon: Plane, title: "Travel Planner", desc: "Pack smart for any trip", testId: "tool-travel" },
  { to: "/family", icon: Users, title: "Family Wardrobes", desc: "Shared closets, growth forecasts", testId: "tool-family" },
  { to: "/beauty/makeup",     icon: Palette,    title: "Makeup Studio",   desc: "Palettes matched to your scan",         testId: "tool-makeup-beauty" },
  { to: "/beauty/hair-beard", icon: Scissors,   title: "Hair & Beard",    desc: "Styles for your face shape",            testId: "tool-hair-beauty" },
  { to: "/beauty/care",       icon: Droplet,    title: "Care Point",      desc: "Skin · hair · scalp routine",           testId: "tool-care-beauty" },
];

export default function Tools() {
  return (
    <div className="max-w-7xl mx-auto px-6 lg:px-10 py-10 lg:py-16">
      <p className="eyebrow flex items-center gap-2"><Sparkles size={12} /> Stylebay · Tools</p>
      <h1 className="editorial-h1 mt-3">Every tool, one place.</h1>
      <p className="text-sm text-muted-foreground mt-3 max-w-xl">
        The full AI atelier — pick any tool below or peek at what&apos;s arriving next.
      </p>

      <div className="mt-12 grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4" data-testid="tools-grid">
        {TOOLS.map((t) => (
          <Link
            key={t.to}
            to={t.to}
            data-testid={t.testId}
            className="group relative border border-border bg-card p-6 hover:border-foreground transition-all duration-300 hover:-translate-y-1"
          >
            <div className="h-11 w-11 inline-flex items-center justify-center bg-muted group-hover:bg-accent group-hover:text-accent-foreground transition-colors mb-5">
              <t.icon size={20} strokeWidth={1.4} />
            </div>
            <p className="font-serif text-2xl leading-tight">{t.title}</p>
            <p className="text-xs text-muted-foreground mt-2 leading-relaxed">{t.desc}</p>
            <ArrowUpRight size={16} className="absolute top-4 right-4 opacity-0 group-hover:opacity-100 group-hover:rotate-12 transition-all" />
          </Link>
        ))}
      </div>

      <div className="mt-20 border-t border-border pt-10">
        <Link
          to="/coming-soon"
          data-testid="tools-coming-soon-cta"
          className="group flex items-center justify-between p-6 border border-dashed border-border hover:border-foreground transition-all"
        >
          <div>
            <p className="eyebrow text-accent">Roadmap</p>
            <p className="font-serif text-2xl mt-2">See what&apos;s coming next.</p>
            <p className="text-xs text-muted-foreground mt-1">Stylist Marketplace · OutfitJudge AI · Color Palette Analyzer · Closet Cleanout · and more.</p>
          </div>
          <ArrowRight size={20} className="group-hover:translate-x-1 transition-transform shrink-0" />
        </Link>
      </div>
    </div>
  );
}
